import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Button from 'material-ui/Button';
import classNames from 'classnames';
import CheckCircle from "../../Icons/CheckCircle";
import SendLetter from "../../Icons/SendLetter";
import FollowCall from "../../Icons/FollowCall";
import { connect } from 'react-redux';
import { postLetterOrdersSalesforceSync } from '../../../redux/actions/LetterOrderList';
import { postFollowCallOrdersSalesforceSync } from '../../../redux/actions/FollowCallOrder';
import ArrowToolTip from "../../common/ArrowToolTip";
import { isSyncing, isSyncFailed, isSynced, isPartSynced } from '../../../utils/salesforceUtils';
import { ORDER_TYPES } from "../../../constants/OrderValues";

const styles = () => ({
  salesforceSyncText: {
    display: "flex",
    alignItems: 'center',
    marginRight: 25,
    marginLeft: 15,
    whiteSpace: 'nowrap',
  },

  btn: {
    height: "33px",
    minWidth: "118px",
    borderRadius: "2px",
    fontSize: "13px",
    textTransform: 'none',
    whiteSpace: 'nowrap',
    display: 'block',
  },

  btnEnable: {
    border: "1px solid #1A65FF",
    background: "#FFFFFF",
    color: "#1A65FF",
    "&:hover": {
      background: "#1A65FF",
      color: '#FFFFFF',
    },
  },

  btnDisable: {
    border: "1px solid #ECEDEF",
    background: "#ECEDEF",
    color: "#000000",
  },

  icon: {
    marginRight: 5,
    height: "15px",
    width: "15px",
  },

  statusIcon: {
    width: "18px",
    height: "18px",
    background: "#F2F6FF",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "5px",
  },
});

/**
 * レター、フォローコール注文のSalesforce同期ボタン
 */
class SalesforceSync extends React.Component {
  handleClick = () => {
    const { type, item, addressImportMappingsFlag, exeExportMappingsFlag, timelineStatusExportMappingsFlag } = this.props;
    if (this.isExe() && !exeExportMappingsFlag) {
      this.props.displayNotification("「キーマンデータベース」の設定がありません。アカウント管理より設定いただけます。", "error")
    } else if (!this.isExe() && !addressImportMappingsFlag) {
      this.props.displayNotification("「自社リスト」の設定がありません。アカウント管理より設定いただけます。", "error")
    } else if (isPartSynced(item, type) && !timelineStatusExportMappingsFlag) {
      this.props.displayNotification("「タイムライン」の設定がありません。アカウント管理より設定いただけます。", "error")
    } else {
      this.handlePostSalesforceSync();
    }
  }

  handlePostSalesforceSync = () => {
    const { type, item } = this.props;

    if (type === ORDER_TYPES.LETTER) {
      this.props.postLetterOrdersSalesforceSync({ letter_order_id: [item.id] });
    } else if (type === ORDER_TYPES.FOLLOW_CALL) {
      this.props.postFollowCallOrdersSalesforceSync({ follow_call_order_id: [item.id] });
    }
  }

  renderIcon = () => {
    const { classes, type } = this.props;

    return (
      <div className={classes.statusIcon} style={{ backgroundColor: "#F2F6FF" }}>
        {(() => {
          if (type === ORDER_TYPES.LETTER) {
            return (<SendLetter width={15} height={15} color="#6F9EFF" />);
          } else if (type === ORDER_TYPES.FOLLOW_CALL) {
            return (<FollowCall width={10} height={10} color="#6F9EFF" />);
          } else {
            return null;
          }
        })()}
      </div>
    );
  }

  isExe = () => {
    const { item } = this.props;
    return item.latest_order_address && item.latest_order_address.executive_person_id;
  }

  render() {
    const { classes, item, type } = this.props;
    return (
      <React.Fragment>
        {(() => {
          if (isSyncing(item, type) || isSynced(item, type)) {
            return (
              <div className={classes.salesforceSyncText}>
                {this.renderIcon()}
                <CheckCircle
                  color="#1A65FF"
                  width={15}
                  height={15}
                  className={classes.icon}
                />
                {isSynced(item, type) ? 'Salesforceと同期済' : 'Salesforceと同期中'}
              </div>
            );
          } else {
            return (
              <ArrowToolTip
                text={isSyncFailed(item, type) ? "同期に失敗した可能性があります。再度同期してください。" :
                      isPartSynced(item, type) ? (this.props.type === ORDER_TYPES.LETTER ? "レター" : "フォローコール") + "の注文はキャンペーンに同期されてますが、" + (this.props.type === ORDER_TYPES.LETTER ? "発送ステータス" : "コール履歴") + "で同期されてないものがあります。" :
                      (this.props.type === ORDER_TYPES.LETTER ? "レター" : "フォローコール") + "注文がキャンペーンに同期されます。"}
                placement="top"
              >
                <div>
                  <Button
                    className={classNames(classes.btn, this.props.isPosting ? classes.btnDisable : classes.btnEnable)}
                    disabled={this.props.isPosting}
                    onClick={() => this.handleClick()}
                    style={{ marginRight: 10, minWidth: 162 }}
                  >
                    <div style={{ display: "flex" }}>
                      {this.renderIcon()}
                      <div>
                        {isSyncFailed(item, type) ? "Salesforceと同期する(同期失敗)" :
                        isPartSynced(item, type) ? "Salesforceと同期する(一部同期済み)" : "Salesforceと同期する"}
                      </div>
                    </div>
                  </Button>
                </div>
              </ArrowToolTip>
            );
          }
        })()}
      </React.Fragment>
    )
  }
}

SalesforceSync.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  postLetterOrdersSalesforceSync: PropTypes.func.isRequired,
  postFollowCallOrdersSalesforceSync: PropTypes.func.isRequired,
  displayNotification: PropTypes.func.isRequired,
  type: PropTypes.number.isRequired,
  addressImportMappingsFlag: PropTypes.bool,
  exeExportMappingsFlag: PropTypes.bool,
  timelineStatusExportMappingsFlag: PropTypes.bool,
  isPosting: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    addressImportMappingsFlag: state.salesforce.address_import_mappings_flag,
    exeExportMappingsFlag: state.salesforce.exe_export_mappings_flag,
    timelineStatusExportMappingsFlag: state.salesforce.timeline_status_export_mappings_flag,
    isPosting: state.letterOrderList.isPostingSalesforceSync || state.followCallOrder.isPostingSalesforceSync,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    postLetterOrdersSalesforceSync(data) {
      dispatch(postLetterOrdersSalesforceSync(data));
    },
    postFollowCallOrdersSalesforceSync(data) {
      dispatch(postFollowCallOrdersSalesforceSync(data));
    },
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesforceSync));



// WEBPACK FOOTER //
// ./src/components/OrderList/parts/SalesforceSync.jsx